import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress noisy cross-origin "Script error." from 3rd-party embeds
// (Razorpay payment button, Stripe, etc) so CRA's dev overlay doesn't
// keep popping up. This only filters opaque cross-origin errors; real
// app errors still surface normally.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      const msg = e?.message || "";
      const src = e?.filename || "";
      const isOpaque = msg === "Script error." || msg === "Script error";
      const isThirdParty = /razorpay|stripe|checkout\./i.test(src);
      if (isOpaque || isThirdParty) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
  window.addEventListener("unhandledrejection", (e) => {
    const reason = String(e?.reason || "");
    if (/razorpay|stripe/i.test(reason)) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
